interface ConversionTable {
    [previousUnit: string]: {
        [unit: string]: number
    }
}


export const flowConverter = (unit: string, previousUnit: string): number | null=> {


    const conversionTable:ConversionTable  = {
        'l/s': {
            'l/s': 1,
            'm3/h': 3.6,
            'gpm': 15.8503,
            'MGD': 0.022824,
            'gps': 0.264172,
            'cfs': 0.0353147,
            'GPD': 22712,
            'Ml/d': 0.0864,
            'L/min': 60
        },
        'm3/h': {
            'l/s': 1 / 3.6,
            'm3/h': 1,
            'gpm': 4.40287,
            'MGD': 0.0063401,
            'gps': 0.073986,
            'cfs': 0.009810,
            'GPD': 6310,
            'Ml/d': 0.024,
            'L/min': 16.666666
        },
        'gpm': {
            'l/s': 1 / 15.8503,
            'm3/h': 1 / 4.40287,
            'gpm': 1,
            'MGD': 0.00144,
            'gps': 0.01667,
            'cfs': 0.002228,
            'GPD': 1440,
            'Ml/d': 0.00545,
            'L/min': 3.78541
        },
        'MGD': {
            'l/s': 1 / 0.022824,
            'm3/h': 1 / 0.0063401,
            'gpm': 1 / 0.00144,
            'MGD': 1,
            'gps': 1.201,
            'cfs': 1.547,
            'GPD': 1_000_000,
            'Ml/d': 3.785,
            'L/min': 2_626.91
        },
        'gps': {
            'l/s': 1 / 0.264172,
            'm3/h': 1 / 0.073986,
            'gpm': 1 / 0.01667,
            'MGD': 1 / 1.201,
            'gps': 1,
            'cfs': 0.133681,
            'GPD': 86_400,
            'Ml/d': 0.327,
            'L/min': 227.125
        },
        'cfs': {
            'l/s': 1 / 0.0353147,
            'm3/h': 1 / 0.009810,
            'gpm': 1 / 0.002228,
            'MGD': 1 / 1.547,
            'gps': 1 / 0.133681,
            'cfs': 1,
            'GPD': 646_317,
            'Ml/d': 2.447,
            'L/min': 1699.01
        },
        'GPD': {
            'l/s': 1 / 22712,
            'm3/h': 1 / 6310,
            'gpm': 1 / 1440,
            'MGD': 1 / 1_000_000,
            'gps': 1 / 86_400,
            'cfs': 1 / 646_317,
            'GPD': 1,
            'Ml/d': 0.000003785,
            'L/min': 0.002628
        },
        'Ml/d': {
            'l/s': 11.574,
            'm3/h': 41.667,
            'gpm': 183.45,
            'MGD': 0.264,
            'gps': 0.264,
            'cfs': 0.409,
            'GPD': 264_172,
            'Ml/d': 1,
            'L/min': 694.44

        },
        'L/min': {
            'l/s': 1 / 60,
            'm3/h': 0.06,
            'gpm': 0.2642,
            'MGD': 0.0003805,
            'gps': 0.004404,
            'cfs': 0.0005886,
            'GPD': 380.51,
            'Ml/d': 0.00144,
            'L/min': 1
        }
    };

    if (!previousUnit || !conversionTable[previousUnit] || !conversionTable[previousUnit][unit]) {
        return null
    }

    return conversionTable[previousUnit][unit];
};

// can be used for totaliser and also consumption
export const totalConverter = (unit: string, previousUnit: string): number | null => {

    const conversionTable:ConversionTable = {
        'l': {
            'l': 1,
            'm3': 1 / 1000 ,
            'gal': 0.264172,
            'ft3': 0.03531
        },
        'm3': {
            'm3': 1,
            'l': 1000,
            'gal': 264.172,
            'ft3': 35.3147
        },
        'gal': {
            'gal': 1,
            'l': 3.78541,
            'm3': 0.00378541,
            'ft3': 0.133681
        },
        'ft3': {
            'ft3': 1,
            'l': 28.3168,
            'm3': 0.0283168,
            'gal': 7.48052
        }
    }

    if (!previousUnit || !conversionTable[previousUnit] || !conversionTable[previousUnit][unit]) {
        return null
    }
    return conversionTable[previousUnit][unit]

}


export const pressureConverter = (unit: string, previousUnit: string): number | null => {
 
    if (unit === 'mH2O' || unit === 'mH20' ) {
        unit = 'mwg'
    }
    if (previousUnit === 'mH2O' || previousUnit === 'mH20' ) {
        previousUnit = 'mwg'
    }
    const conversionTable: ConversionTable = {
        'bar': {
            'bar': 1,
            'mb': 1000,
            'mwg': 10.1972,
            'psi': 14.5038,
            'kPa': 100,
            'ftH2O': 33.46,
            'kg/cm2': 1.01972
        },
        'mb': {
            'mb' : 1,
            'bar': 0.001,
            'mwg': 0.0101972,
            'psi': 0.0145038,
            'kPa': 0.1,
            'ftH2O': 0.03346,
            'kg/cm2': 0.00101972
        },
        'mwg': {
            'mwg': 1,
            'bar': 0.0980665,
            'mb': 9.80665,
            'psi': 0.0142233,
            'kPa': 0.0980665,
            'ftH2O': 3.281,
            'kg/cm2': 0.1
        },
        'psi': {
            'psi': 1,
            'bar': 0.0689476,
            'mwg': 70.307,
            'mb': 68.9476,
            'kPa': 6.89476,
            'ftH2O': 2.307,
            'kg/cm2': 0.070307
        },
        'kPa': {
            'kPa': 1,
            'bar': 0.01,
            'mb': 10,
            'mwg': 0.101972,
            'psi': 0.145038,
            'ftH2O': 0.3346,
            'kg/cm2': 0.0101972 
        },
        'ftH2O': {
            'kPa': 2.989,
            'bar': 0.02989,
            'mb': 29.89,
            'mwg': 0.3048,
            'psi': 0.433,
            'ftH2O': 1,
            'kg/cm2': 0.030481
        },
        'kg/cm2': {
            'kg/cm2': 1,
            'bar': 0.980665,
            'mb': 0.00101972,
            'mwg': 10,
            'psi': 14.2233,
            'ftH2O': 32.8084,
            'kPa': 98.0665
        }
    }

    if (!previousUnit || !conversionTable[previousUnit] || !conversionTable[previousUnit][unit]) {
        return null
    }
    return conversionTable[previousUnit][unit]
}

export const flowRateUnits = [
    { name: 'l/s', value: 'l/s' },
    { name: 'm3/h', value: 'm3/h' },
    { name: 'million gal/day (MGD)', value: 'MGD' },
    { name: 'gal/day (GPD)', value: 'GPD' },
    { name: 'gal/s (gps)', value: 'gps' },
    { name: 'feet3/s (cfs)', value: 'cfs' }
]

export const flowUnits = [
    { name: 'l', value: 'l' },
    { name: 'm3', value: 'm3' },
    { name: 'gal', value: 'gal' },
    { name: 'ft3', value: 'ft3' }
]

export const pressureUnits = [
    { name: 'bar', value: 'bar' },
    { name: 'millibar', value: 'mb' },
    { name: 'mH2O', value: 'mH2O' },
    { name: 'mwg', value: 'mwg' },
    { name: 'psi', value: 'psi' },
    { name: 'ftH2O', value: 'ftH2O' },
    { name: 'kPa', value: 'kPa'},
    {name: 'kg/cm2', value: 'kg/cm2'}
]


